import * as React from "react";
const SvgFiBrandsBitcoin = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 25 24"
    {...props}
  >
    <g fill="#151A2D" clipPath="url(#fi-brands-bitcoin_svg__a)">
      <path d="M14.875 14.509c-.424 1.635-3.29.751-4.22.53l.752-2.899c.93.223 3.911.664 3.468 2.369M15.3 10.267c-.387 1.486-2.774.73-3.548.546l.683-2.629c.774.185 3.267.531 2.864 2.083" />
      <path d="M15.522.36C8.827-1.245 2.044 2.67.376 9.097c-1.67 6.428 2.405 12.94 9.099 14.543 6.697 1.603 13.48-2.31 15.149-8.738 1.67-6.429-2.405-12.941-9.102-14.544M9.927 8.095c.017-.28-.083-.633-.64-.766.022-.014-.995-.238-.995-.238l.365-1.406 1.892.453-.002.008q.427.1.876.197l.563-2.162 1.37.328-.55 2.12c.367.081.737.162 1.098.249l.547-2.106 1.371.328-.561 2.163c1.73.572 2.997 1.43 2.749 3.027-.18 1.17-.856 1.735-1.752 1.933 1.23.615 1.857 1.559 1.26 3.194-.74 2.03-2.499 2.202-4.838 1.777l-.567 2.183-1.371-.328.56-2.154a53 53 0 0 1-1.093-.272l-.562 2.164-1.37-.329.568-2.187q-.48-.121-.979-.242l-1.784-.428.68-1.507s1.01.258.998.24c.388.091.56-.152.628-.314z" />
    </g>
    <defs>
      <clipPath id="fi-brands-bitcoin_svg__a">
        <path fill="#fff" d="M0 0h25v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiBrandsBitcoin;
